import type {
  AddCustomDomainOutput,
  CustomDomainDnsCheckOutput,
  DeleteCustomDomainOutput,
  FindCustomDomainsOutput,
  GetCustomDomainOutput,
  SetPrimaryCustomDomainOutput,
  VerifyCustomDomainOutput,
} from "schemas/generated/customDomain";
import type { RequestFn } from "./request";

export function createCustomDomainsClient({ request }: { request: RequestFn }) {
  return {
    find: (input: { projectId: string; siteId: string }) => {
      return request<FindCustomDomainsOutput>({
        method: "GET",
        path: "/api/v1/custom-domains",
        query: { projectId: input.projectId, siteId: input.siteId },
      });
    },
    add: (input: { projectId: string; siteId: string; domain: string }) => {
      return request<AddCustomDomainOutput>({
        method: "POST",
        path: "/api/v1/custom-domains",
        body: input,
      });
    },
    get: (input: { customDomainId: string }) => {
      return request<GetCustomDomainOutput>({
        method: "GET",
        path: `/api/v1/custom-domains/${encodeURIComponent(input.customDomainId)}`,
      });
    },
    getDnsCheck: (input: { customDomainId: string }) => {
      return request<CustomDomainDnsCheckOutput>({
        method: "GET",
        path: `/api/v1/custom-domains/${encodeURIComponent(input.customDomainId)}/dns-check`,
      });
    },
    verify: (input: { customDomainId: string }) => {
      return request<VerifyCustomDomainOutput>({
        method: "POST",
        path: `/api/v1/custom-domains/${encodeURIComponent(input.customDomainId)}/verify`,
      });
    },
    setPrimary: (input: { customDomainId: string }) => {
      return request<SetPrimaryCustomDomainOutput>({
        method: "POST",
        path: `/api/v1/custom-domains/${encodeURIComponent(input.customDomainId)}/set-primary`,
      });
    },
    delete: (input: { customDomainId: string }) => {
      return request<DeleteCustomDomainOutput>({
        method: "DELETE",
        path: `/api/v1/custom-domains/${encodeURIComponent(input.customDomainId)}`,
      });
    },
  };
}

export type CustomDomainsClient = ReturnType<typeof createCustomDomainsClient>;
